module.exports = "\u0003�RCopyright 1990-2009 Adobe Systems Incorporated.\nAll rights reserved.\nSee ./LICENSE�\u0006CNS2-H"